export interface ICalendarNote {
  clientNo?: string;
  eventOn: string;
  _eventOnTimestamp?: number;
  eventPlace?: string;
  eventType: ECalenderNoteType;
  note: string;
  title: string;
  userName: string;
  id?: number;
}

export enum ECalenderNoteType {
  meeting = 'MEETING',
  note = 'NOTE',
  task = 'TASK',
}

// Function to generate sample calendar notes
export function generateSampleCalendarNotes(
  count: number = 5,
): Omit<ICalendarNote, 'userName' | 'clientNo' | 'id'>[] {
  const today = new Date();
  const notes: Omit<ICalendarNote, 'userName' | 'clientNo' | 'id'>[] = [];

  const eventTypes = Object.values(ECalenderNoteType);
  const eventPlaces = [
    'Conference Room A',
    'Conference Room B',
    'Virtual Meeting',
    'Client Office',
    'Café Bistro',
    'Downtown Restaurant',
    'Home Office',
    'Branch Office',
    'Training Center',
    'Executive Suite',
    'Innovation Lab',
    'Partner Office',
  ];

  const eventTitles = [
    'Team Standup',
    'Client Meeting',
    'Project Review',
    'Strategy Session',
    'Training Workshop',
    'Product Demo',
    'Quarterly Planning',
    'Performance Review',
    'Compliance Update',
    'Sales Pitch',
    'Partnership Discussion',
    'Budget Review',
    'Marketing Campaign',
    'System Update',
    'Customer Feedback',
    'Team Building',
  ];

  const noteTemplates = [
    'Discuss project timeline and deliverables with the team.',
    'Review quarterly performance metrics and set goals for next quarter.',
    'Prepare presentation materials for upcoming client meeting.',
    'Follow up on action items from previous meeting.',
    'Coordinate with marketing team on upcoming product launch.',
    'Review and approve budget proposals for next fiscal year.',
    'Conduct training session on new system features.',
    'Meet with potential client to discuss service offerings.',
    'Analyze customer feedback and identify improvement areas.',
    'Brainstorm ideas for upcoming marketing campaign.',
  ];

  // Generate dates centered around today (-15 to +15 days)
  for (let i = 0; i < count; i++) {
    const dayOffset = Math.floor(Math.random() * 31) - 15; // -15 to +15 days
    const date = new Date(today);
    // date.setDate(today.getDate() + dayOffset);

    // Random time between 8:00 AM and 8:00 PM
    const hour =3;
    // const hour = Math.floor(Math.random() * 12) + 8;
    const minute = [0, 15, 30, 45][Math.floor(Math.random() * 4)];
    date.setHours(hour, minute, 0, 0);

    const eventType = eventTypes[Math.floor(Math.random() * eventTypes.length)];
    const eventPlace = eventPlaces[Math.floor(Math.random() * eventPlaces.length)];
    const title = eventTitles[Math.floor(Math.random() * eventTitles.length)];

    // Generate a note under 100 characters
    let note = noteTemplates[Math.floor(Math.random() * noteTemplates.length)];
    if (note.length > 100) {
      note = note.substring(0, 97) + '...';
    }

    notes.push({
      eventOn: date.toISOString().slice(0, 19),
      eventPlace,
      eventType,
      note,
      title,
    });
  }

  // Sort by date
  return notes.sort((a, b) => new Date(a.eventOn).getTime() - new Date(b.eventOn).getTime());
}

// Sample usage:
// const sampleCalendarNotes = generateSampleCalendarNotes();
